import { NavLink, useLocation } from "react-router-dom";

const MenuItem = ({ to, label }) => {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <li className={`menu-item ${isActive ? "active" : ""}`}>
            <NavLink to={to} className={`menu-link ${isActive ? "active" : ""}`}>
                <span className="menu-bullet"></span>
                <span className="menu-label">{label}</span>
            </NavLink>
        </li>
    );
};

export default MenuItem;
